// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PWA1","icon":"styles_icon__7SwRW"};